import { render } from "./ChooseSeat.vue?vue&type=template&id=79c2cc5a"
import script from "./ChooseSeat.vue?vue&type=script&lang=js"
export * from "./ChooseSeat.vue?vue&type=script&lang=js"

import "./ChooseSeat.vue?vue&type=style&index=0&id=79c2cc5a&lang=css"

import exportComponent from "D:\\react js\\VET_VUE\\VET-mini-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__